import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

/** `?session=<id>` opens the session drawer on whichever page mounts the host. */
export function useSessionParam(): [string | null, (id: string | null, opts?: { replace?: boolean }) => void] {
  const [params, setParams] = useSearchParams();
  const id = params.get('session');
  const set = useCallback(
    (next: string | null, opts: { replace?: boolean } = {}) => {
      setParams(
        (prev) => {
          const p = new URLSearchParams(prev);
          if (next) p.set('session', next);
          else p.delete('session');
          return p;
        },
        { replace: opts.replace ?? !next, preventScrollReset: true },
      );
    },
    [setParams],
  );
  return [id, set];
}
